/**
 * Authenticated LMS shells that should use a compact app footer
 * instead of the public marketing footer.
 */
export function isLmsAppShellPath(pathname: string): boolean {
  const path = pathname.split('?')[0] || '/';
  if (path === '/teach' || path.startsWith('/teach/')) {
    return true;
  }
  if (path === '/me' || path.startsWith('/me/')) {
    return true;
  }
  if (path.startsWith('/student/event/')) {
    return true;
  }
  if (path.startsWith('/instructor/event/')) {
    return true;
  }
  if (path === '/dashboard' || path.startsWith('/dashboard/')) {
    return true;
  }
  return false;
}
